import {useSearchParams} from "react-router-dom";
import Profile from "../components/Profile";

const OtherProfile = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    let username = searchParams.get("username")

    return (
        <Profile username={username} ownProfile={false}/>
    )
}

export default OtherProfile;